'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*

  Declare and export all DOM strings here

  e.g.

  export default {
    inlineCart: '[data-inline-cart]',
    inlineCartContents: '[data-inline-cart-contents]',
  };

  Usage:

  import dom from 'common/Dom';
  import { getCartContents } from './handlers';

  $(dom.inlineCartContents).html(getCartContents());

*/
var dom = {
  isActive: '.is-active',
  isActiveSelector: '.is-active',
  isActiveClassName: 'is-active',

  joke: '[data-new-joke]',
  navigationLink: '[data-nav-link]',
  navigationSearch: '[data-nav-search]',
  menuItemTrigger: '[data-dropdown-menu-trigger]',
  menuContainer: '[mobile-menu-container]',
  menuLevelTrigger: '[data-menu-next]',
  menuLevelContent: '[data-menu-content]',
  menuLevelClose: '[data-menu-close]',
  breadcrumbs: '[data-breadcrumbs-container]',
  collectionBreadcrumb: '[data-collection-breadcrumb]',

  quickshopSlider: '[data-quickshop-slider]',
  quickshopThumbnail: '[data-quickshop-trigger]',
  quickshopSlide: '[data-quickshop-slide]',

  overlay: '[data-overlay]',

  toggle: '[data-toggle]',

  container: '[data-container]',

  slider: '[data-slider]',

  modal: '[data-modal]',
  modalContents: '[data-modal-contents]',
  openModal: '[data-open-modal]',
  closeModal: '[data-close-modal]',
  toggleModal: '[data-toggle-modal]',

  indicatorWrapper: 'data-cart-count-wrapper',
  indicator: 'data-cart-count',

  closeInlineCart: '[data-close-inline-cart]',
  toggleInlineCart: '[data-toggle-inline-cart]',
  openInlineCart: '[data-open-inline-cart]',
  inlineCart: '[data-inline-cart]',
  inlineCartContents: '[data-inline-cart-contents]',

  discreteShippingToggle: '[data-discrete-shipping-toggle]',

  lineItemContainer: '[data-container="line-item"]',
  lineItemKey: '[data-line-item-key]',
  lineItemData: '[data-line-item-data]',

  image360Container: '[data-container="image360"]',
  image360Data: '[data-image360-data]',
  image360: '[data-image360]',

  productContainer: '[data-container="product"]',
  selectedOptionValue: '[data-selected-option-value]',
  imageData: '[data-image-data]',
  optionData: '[data-option-data]',
  optionValue: '[data-option-value]',
  variantData: '[data-variant-data]',
  productData: '[data-product-data]',
  windowsVariantSelect: '[data-windows-variant-selector]',

  addToCart: '[data-add-to-cart]',
  removeFromCart: '[data-remove-from-cart]',

  quantityValue: '[data-quantity-value]',
  quantityChange: '[data-quantity-change]',

  sizeGuide: '[data-size-guide]',
  price: '[data-price="price"]',
  compareAtPrice: '[data-price="compare_at_price"]',

  productGallerySlide: '[data-product-gallery-slide]',

  sliderHasNav: '[data-has-nav]',

  sliderFilterValue: '[data-filter-value]',

  galleryThumb: '[data-gallery-thumb]',
  gallerySlide: '[data-gallery-slide]',

  openQuickshop: '[data-open-quickshop]',

  contactForm: '[data-contact-form]',
  contactSuccessMessage: '[data-contact-form-success]',
  contactInputWrapper: '[data-contact-input-wrapper]',
  contactInput: '[data-contact-input]',
  contactInputClear: '[data-contact-clear]',

  getContainer: function getContainer(key) {
    var asjQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    if (key instanceof Element) {
      return asjQuery ? $(key).closest(dom.container) : $(key).closest(dom.container)[0];
    } else if ($('[data-container-id="' + key + '"]', context).length) {
      return asjQuery ? $('[data-container-id="' + key + '"]', context) : $('[data-container-id="' + key + '"]', context)[0];
    } else if ($('[data-container-name="' + key + '"]', context).length) {
      return asjQuery ? $('[data-container-name="' + key + '"]', context) : $('[data-container-name="' + key + '"]', context)[0];
    } else if ($('[data-container="' + key + '"]', context).length) {
      return asjQuery ? $('[data-container="' + key + '"]', context) : $('[data-container="' + key + '"]', context).get();
    }

    return;
  },

  getContainers: function getContainers(type) {
    return $('[data-container="' + type + '"]').get();
  },
  $getContainers: function $getContainers(type) {
    return $('[data-container="' + type + '"]');
  },

  getSelf: function getSelf(self) {
    return $(self).closest(dom.container)[0];
  },
  $getSelf: function $getSelf(self) {
    return $(self).closest(dom.container);
  },

  getParentContainer: function getParentContainer(self) {
    var levels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var asjQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (levels !== 0) {
      var parentContainer = dom.getContainer($(self).parent()[0]);
      return dom.getParentContainer(parentContainer, levels - 1);
    }
    return asjQuery ? dom.getContainer(self, true) : dom.getContainer(self);
  },

  priceString: function priceString(priceInCents) {
    return '$' + (priceInCents / 100).toFixed(2);
  }
};
window.a = dom.getParentContainer;

exports.default = dom;